;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"0.1.0"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.3.5";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/tik-me-web/1759057792440_prod";globalThis["_sentryAssetPrefix"] = "https://metac-open.oss-cn-hangzhou.aliyuncs.com/tik-me-web/1759057792440_prod";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/arena\"},{\"path\":\"/arena/room\"},{\"path\":\"/arena-back\"},{\"path\":\"/arena-back/room\"},{\"path\":\"/assets\"},{\"path\":\"/bounty-club\"},{\"path\":\"/effects\"},{\"path\":\"/effects-detail\"},{\"path\":\"/face-swap\"},{\"path\":\"/home\"},{\"path\":\"/image-to-video\"},{\"path\":\"/pricing\"},{\"path\":\"/text-to-image\"},{\"path\":\"/text-to-video\"},{\"path\":\"/pdf/payment-policy\"},{\"path\":\"/pdf/privacy-policy\"},{\"path\":\"/pdf/terms-of-use\"}]}";import { initGlobalSentry } from './lib/sentry'

const shouldEnableSentry = process.env.NODE_ENV !== 'development'

if (shouldEnableSentry) {
  const initSentry = async () => {
    try {
      // 生产环境：启用性能监控和会话回放，但采样率较低
      initGlobalSentry({
        dsn: 'https://df50de8af5e3ac29947eb40ac24824c6@sentry-zddev.metac-inc.com/2',
        environment: process.env.NODE_ENV,
        release: process.env.npm_package_version || '1.0.0',
      })

      console.log(`Sentry initialized with ${process.env.NODE_ENV} configuration`)
    }
    catch (error) {
      console.error('Failed to initialize Sentry:', error)
    }
  }

  initSentry()
}
